var crate_select2 = (function( $ ) {

	var _init = function() {
		$( 'select.select2' ).select2();
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = crate_select2;